import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'
import { routes } from './route-data'
// 简单配置
NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })

Vue.use(Router)

routes.push(...[
  {
    path: '/login',
    component: () => import('@/views/Login.vue'),
    meta: { anonymous: true, hidden: true, isPageAutoScroll: true }
  },
  // {
  //   path: '/404',
  //   component: () => import('@/views/Error/404.vue'),
  //   meta: { anonymous: true, hidden: true }
  // },
  // { path: '*', redirect: '/404', meta: { anonymous: true, hidden: true } }
])

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeEach((to, from, next) => {
  console.log('to',to)
  console.log('store',store.state.user.menus);
  let roleMenus = store.state.user.menus;
  if(!roleMenus.includes(to.fullPath) && to.fullPath !== '/404'){
    // next({
    //   path:'/404',
    // });
  }
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router

export {
  routes
}
